export default "__VITE_PUBLIC_ASSET__255c61f4__"